import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NgxEditorModule } from 'ngx-editor';
import { TagInputModule } from 'ngx-chips';

import { SharedModule } from '@shared/shared.module';

import { QuotationComponent } from './quotation.component';

import { QuoteFormComponent } from './quote-form/quote-form.component';
import { SendEmailComponent } from './send-email/send-email.component';
import { ProductDetailComponent } from './product-detail/product-detail.component';
import { CaptureScreenModalComponent } from './capture-screen-modal/capture-screen-modal.component';

const route: Routes = [
  {
    path: '',
    component: QuotationComponent
  }
];

@NgModule({
    declarations: [SendEmailComponent, QuotationComponent, QuoteFormComponent, ProductDetailComponent, CaptureScreenModalComponent],
    imports: [SharedModule, TagInputModule, NgxEditorModule, RouterModule.forChild(route)]
})
export class QuotationModule {}
